/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import InnovationIllustration from 'svg/illustrations/Innovation';
import handleOpenWhatsApp from 'services/whatsappService';

const AreYouReady = ({ content = {} }) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const whatsappRaw = content.whatsappNumber || '';
  const openWhatsApp = () => {
    if (whatsappRaw) {
      const digits = String(whatsappRaw).replace(/\D/g, '');
      window.open(`https://wa.me/${digits}`, '_blank', 'noopener,noreferrer');
      return;
    }
    handleOpenWhatsApp();
  };

  return (
    <Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 700 }}
        variant={'h2'}
        gutterBottom
        align={'center'}
        marginBottom={'2rem'}
      >
        {content.headline || 'Únete a TNO Media Lab'}
      </Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 600 }}
        variant={'h4'}
        gutterBottom
        align={'center'}
        marginBottom={'2rem'}
        color="textSecondary"
      >
        {content.subheadline || '¿Estás listo para profesionalizar tu visión?'}
      </Box>

      <Grid container spacing={4}>
        <Grid item container alignItems={'center'} xs={12} md={6}>
          <Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
            <Box marginBottom={2}>
              <Typography
                variant="h3"
                color="textPrimary"
                sx={{
                  fontWeight: 700,
                }}
              >
                {content.body ? (
                  content.body
                ) : (
                  <>
                    Ya seas un productor independiente buscando dar el salto o una marca personal persiguiendo autoridad,{' '}
                    <Typography color={'primary'} component={'span'} variant={'inherit'}>
                      TNO Media Lab
                    </Typography>{' '}
                    es tu casa.
                  </>
                )}
              </Typography>
            </Box>
            {!content.body && (
              <Box marginBottom={3}>
                <Typography variant="h6" component="p" color="textSecondary" sx={{ fontWeight: 400 }}>
                  Desata tu creatividad, aprovecha nuestra tecnología y forma parte de la comunidad que está reinventando los medios en Venezuela.
                </Typography>
              </Box>
            )}
            <Box
              display="flex"
              flexDirection={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretched', sm: 'flex-start' }}
            >
              <Button
                component={'a'}
                variant="contained"
                color="primary"
                size="large"
                fullWidth={isMd ? false : true}
                onClick={openWhatsApp}
                target={'_blank'}
              >
                {content.ctaPrimary || 'Únete al Lab'}
              </Button>
              <Box
                marginTop={{ xs: 2, sm: 0 }}
                marginLeft={{ sm: 2 }}
                width={{ xs: '100%', md: 'auto' }}
              >
                <Button
                  component={'a'}
                  href={content.ctaSecondaryHref || 'https://www.tnonetwork.com'}
                  variant="outlined"
                  color="primary"
                  size="large"
                  fullWidth={isMd ? false : true}
                >
                  {content.ctaSecondary || 'TNO Network'}
                </Button>
              </Box>
            </Box>
            {content.footerText && (
              <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 3 }}>
                {content.footerText}
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            height={'100%'}
            width={'100%'}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Box height={'100%'} width={'100%'} maxHeight={600}>
              <InnovationIllustration width={'100%'} height={'100%'} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

AreYouReady.propTypes = {
  content: PropTypes.object,
};

export default AreYouReady;
